import React from 'react';
import BillProductsForm from './BillProductsForm';
import BillProductsFormService from '../services/BillProductsFormService';
import BillFormService from '../services/BillFormService';
import { observer } from 'mobx-react';
import { get } from 'lodash';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';

class BillProductsFormContainer extends React.Component {
  componentDidMount() {
    BillProductsFormService.init();
  }

  render() {
    return (
      <BillProductsForm
        onChange={BillProductsFormService.handleChange}
        onSubmit={BillProductsFormService.handleSubmit}
        values={BillProductsFormService.form.getValues()}
        errors={BillProductsFormService.form.errors}
        options={toJS(BillProductsFormService.products)}
        disabled={
          BillFormService.fetch.fetching ||
          BillFormService.submit.fetching ||
          !get(BillFormService.form.getValues(), 'contract', null)
        }
        currencyType={
          !BillFormService.form.getValue('country') || BRAZIL.includes(BillFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
      />
    );
  }
}

export default observer(BillProductsFormContainer);
